import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NotFoundComponent } from './component/notfound/notfound.component';
import { LogResolve } from './log.resolve';
import { LoginComponent } from './component/login/login.component';
import { PasswordComponent } from './component/password/password.component';
import { AuComponent } from './component/au/au.component';
import { AuthGuard } from './guard/auth.guard';
import { RoleGuard } from './guard/role.guard';
import { PassGuard } from './guard/pass.guard';
import { OneTimeGuard } from './guard/onetime.guard';
import { OneTimeLoginComponent } from './component/onetimelogin/onetimelogin.component';
export var routes = [
    // route('', {redirectTo: 'top', pathMatch: 'full'}),
    { path: '', redirectTo: 'top-summary-service/list', pathMatch: 'full', canActivate: [AuthGuard], runGuardsAndResolvers: 'always' },
    { path: 'top', redirectTo: 'top-summary-service/list', pathMatch: 'full', canActivate: [AuthGuard], runGuardsAndResolvers: 'always' },
    { path: 'login', resolve: { dummy: LogResolve }, component: LoginComponent, canActivate: [RoleGuard], runGuardsAndResolvers: 'always' },
    { path: 'password', resolve: { dummy: LogResolve }, component: PasswordComponent, canActivate: [AuthGuard, RoleGuard, OneTimeGuard], runGuardsAndResolvers: 'always' },
    { path: 'onetimelogin', resolve: { dummy: LogResolve }, component: OneTimeLoginComponent, canActivate: [AuthGuard, RoleGuard, PassGuard], runGuardsAndResolvers: 'always' },
    {
        path: ':flow',
        resolve: { dummy: LogResolve },
        component: AuComponent,
        canActivate: [AuthGuard, PassGuard, OneTimeGuard, RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: ':flow/list',
        resolve: { dummy: LogResolve },
        component: AuComponent,
        canActivate: [AuthGuard, PassGuard, OneTimeGuard, RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: ':flow/entry',
        resolve: { dummy: LogResolve },
        component: AuComponent,
        canActivate: [AuthGuard, PassGuard, OneTimeGuard, RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: ':flow/confirm',
        resolve: { dummy: LogResolve },
        component: AuComponent,
        canActivate: [AuthGuard, PassGuard, OneTimeGuard, RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: ':flow/view/:id',
        resolve: { dummy: LogResolve },
        component: AuComponent,
        canActivate: [AuthGuard, PassGuard, OneTimeGuard, RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: ':flow/member_search',
        resolve: { dummy: LogResolve },
        component: AuComponent,
        canActivate: [AuthGuard, PassGuard, OneTimeGuard, RoleGuard],
        runGuardsAndResolvers: 'always'
    },
    { path: '**', component: NotFoundComponent },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    AppRoutingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],
                    exports: [RouterModule]
                },] }
    ];
    return AppRoutingModule;
}());
export { AppRoutingModule };
//# sourceMappingURL=app-routing.module.js.map